import { api } from '../core';

export type LogoutResponse = object;

type GetLogoutProps = {
  abortController?: AbortController;
};

const getLogoutApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLogout: builder.query<LogoutResponse, GetLogoutProps>({
      query: ({ abortController = new AbortController() }: GetLogoutProps) => ({
        url: `logout`,
        method: 'GET',
        signal: abortController.signal
      }),
      async onQueryStarted(_arg, { /*dispatch,*/ queryFulfilled }) {
        try {
          await queryFulfilled;

          console.log('User Logged Out');
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getLogout in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetLogoutQuery } = getLogoutApi;
